<template>
    <RouterView />
</template>

<script>
export default {
    name: 'SimpleRouterView',
}
</script>
